import { configureStore } from "@reduxjs/toolkit";
import navigatorReducer from "../features/FormNavigator/navigatorSlice";
import managerDetailsReducer from "../features/1_ManagerDetails/managerDetailsSlice";
import employeeDetailsReducer from "../features/2_EmployeeDetails/employeeDetailsSlice";
import marginManagementReducer from "../features/3.0_MarginManagement/marginManagementSlice";
import processingPlanReducer from "../features/3.1_ProcessingPlan/processingPlanSlice";
import licenseStatesReducer from "../features/3_LicenseStates/licenseStatesSlice";
import branchLocationDetailsReducer from "../features/4_5_6_BranchLocationDetails/branchLocationDetailsSlice";
import lockingCabinetDetailsReducer from "../features/7_LockingCabinet/lockingCabinetSlice";
import localITCompanyDetailsReducer from "../features/8_localITCompanyDetails/localITCompanySlice";
import officeSpaceOtherBusinessDetailsReducer from "../features/9_officeSpaceOtherBusinessDetails/officeSpaceOtherBusinessSlice";
import mortgageSignReducer from "../features/10_mortgageSign/mortgageSignSlice";
import complianceSignageReducer from "../features/11_ComplianceSignage/complianceSignageSlice";
import occupationalLicenseReducer from "../features/12_occupationalLicence/occupationalLicenseSlice";
import summaryReducer from "../features/13_Summary/summarySlice";
import adminReducer from "../admin/adminSlice";
// import { loadFromLocalStorage, saveToLocalStorage } from "./utils";

import marketingDetailsReducer from "../features/12.1_MarketingDetails/marketingDetailsSlice";

// const preloadedState = {
//     navigator: loadFromLocalStorage("navigation"),
//     // branch_location: loadFromLocalStorage("branchLocation"),
// };

export const store = configureStore({
    reducer: {
        navigator: navigatorReducer,
        manager: managerDetailsReducer,
        employees: employeeDetailsReducer,
        margin_management: marginManagementReducer,
        processing_plan: processingPlanReducer,
        license_states: licenseStatesReducer,
        branch_location: branchLocationDetailsReducer,
        locking_cabinet: lockingCabinetDetailsReducer,
        local_it_company: localITCompanyDetailsReducer,
        other_businesses: officeSpaceOtherBusinessDetailsReducer,
        mortgage_sign: mortgageSignReducer,
        compliance_signage: complianceSignageReducer,
        occupational_license: occupationalLicenseReducer,
        marketing: marketingDetailsReducer,
        summary: summaryReducer,
        admin: adminReducer,
    },
    // preloadedState
})

// subscribe to changes in the FormNaviagator Data
// store.subscribe(() => {
//     saveToLocalStorage(store.getState().navigator, "navigation");
// })

// store.subscribe(() => {
//     saveToLocalStorage(store.getState().branch_location, "branchLocation");
// })